import type { PropsWithChildren } from "react";

import { styled } from "@linaria/react";

import { getCssSizeValue } from "../utils/linaria";

const StyledWrapper = styled.div<{
  $position?: React.CSSProperties["position"];
  $minWidth?: number | string;
  $maxWidth?: number | string;
  $fillWidth?: boolean;
  $fillHeight?: boolean;
  $overflow?: React.CSSProperties["overflow"];
  $padding?: React.CSSProperties["padding"];
  $top?: React.CSSProperties["top"];
  $right?: React.CSSProperties["right"];
  $bottom?: React.CSSProperties["bottom"];
  $left?: React.CSSProperties["left"];
}>`
  position: ${({ $position }) => $position ?? "static"};
  min-width: ${({ $minWidth }) => ($minWidth ? getCssSizeValue($minWidth) : "auto")};
  width: ${({ $fillWidth, $maxWidth }) =>
    $fillWidth ? "100%" : $maxWidth ? getCssSizeValue($maxWidth) : "auto"};
  height: ${({ $fillHeight }) => ($fillHeight ? "100%" : "auto")};
  overflow: ${({ $overflow }) => $overflow ?? "visible"};
  padding: ${({ $padding }) => $padding ?? "0"};
  overscroll-behavior: auto;
  top: ${({ $top }) => $top ?? "auto"};
  right: ${({ $right }) => $right ?? "auto"};
  bottom: ${({ $bottom }) => $bottom ?? "auto"};
  left: ${({ $left }) => $left ?? "auto"};
`;

interface WrapperProps {
  position?: React.CSSProperties["position"];
  minWidth?: number | string;
  maxWidth?: number | string;
  fillWidth?: boolean;
  fillHeight?: boolean;
  overflow?: React.CSSProperties["overflow"];
  padding?: React.CSSProperties["padding"];
  top?: React.CSSProperties["top"];
  right?: React.CSSProperties["right"];
  bottom?: React.CSSProperties["bottom"];
  left?: React.CSSProperties["left"];
}

const Wrapper = ({
  children,
  position,
  minWidth,
  maxWidth,
  fillWidth,
  fillHeight,
  overflow,
  padding,
  top,
  right,
  bottom,
  left,
}: PropsWithChildren<WrapperProps>) => {
  return (
    <StyledWrapper
      $position={position}
      $minWidth={minWidth}
      $maxWidth={maxWidth}
      $fillWidth={fillWidth}
      $fillHeight={fillHeight}
      $overflow={overflow}
      $padding={padding}
      $top={top}
      $right={right}
      $bottom={bottom}
      $left={left}
    >
      {children}
    </StyledWrapper>
  );
};

export default Wrapper;
